export const SectionHeading = ({ heading }) => (
  <span className="text-xl font-semibold text-gray-900 pt-10 pb-4">
    {heading}
  </span>
);
